import styled from 'styled-components';
import sctheme from 'app/styles/sctheme';

export const Layout = styled.div`
  position: relative;
  min-width: 100%;
  min-height: 100vh;
  overflow: hidden;
  background-color: ${sctheme.grays.$900};
  background-repeat: no-repeat;
  background-position: center center;
  background-attachment: fixed;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

export const Container = styled.div`
  text-align: center;
  background-color: ${sctheme.grays.$200};
  box-shadow: 0 0 25px rgba(0, 0, 0, 0.25);
  border-radius: 5px;
  padding: 50px;
  max-width: 600px;

  h2 {
    color: ${sctheme.black};
    font-weight: 700;
    margin-bottom: 1rem;
  }

  p {
    color: ${sctheme.grays.$700};
    font-size: 16px;
    line-height: 1.5;
    margin-bottom: 1.5rem;
  }

  a {
    color: ${sctheme.blues.primary};
    text-decoration: none;
    font-weight: 600;

    &:hover {
      text-decoration: underline;
    }
  }

  img {
    display: block;
    margin: 0 auto 1.5rem;
  }
`;
